import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const useRectangleValidationSchema = () => {
	const { t } = useTranslation()

	const rectSchema = yup.object({
		width: yup
			.string()
			.matches(/^[0-9]*$/, t('Only numbers'))
			.required(t('This field is required')),
		height: yup
			.string()
			.matches(/^[0-9]*$/, t('Only numbers'))
			.required(t('This field is required'))
	})

	return yupResolver(rectSchema)
}
